import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Maguey from '../../../img/magueysito.svg'
import LogoMagueySVG from '../../../img/logoBlancoSVG2.svg';

import estilos from './MarcadorDeZonaComponent.module.css'

function MarcadorDeZonaComponent(props) {

    const asociado = props.asociado

    return (
        <Fragment>
        <div className={`${estilos.pin1}`} style={{ backgroundColor: asociado.pin, cursor: 'pointer'}} title={asociado.nombre} >
        <img src={LogoMagueySVG}/>
        <p className='badge' style={{ backgroundColor: 'white', fontSize: '15px', color: 'black' }}>{asociado.nombre}</p>     
        </div> 
        
        </Fragment> 
    );
};


export default withRouter(MarcadorDeZonaComponent)
